export default {
  apiDateFormat: "DD/MM/YYYY",
  urlDateFormat: "DD-MM-YYYY",
  apiUrl: "https://api.skypicker.com",
  locationsApiUrl: "https://api.skypicker.com/locations/",
  bookingApiUrl: "https://booking-api.skypicker.com",
  prebookingApiUrl: "https://booking-api.skypicker.com",
  piciApiUrl: "https://fe.payments-kiwi.com/",
  mmbPiciApiUrl: "https://fe.payments-kiwi.com",
  mmbApiUrl: "https://booking-api.skypicker.com",
  authApiUrl: "https://auth.skypicker.com",
  umbrellaUrl: "https://api.skypicker.com/umbrella/graphql",
  mockApiUrl: "https://skymock-api.skypicker.com",
  logstashApiUrl: "https://loglady.kiwi.com/logmole",
  priceAlertUrl: "https://r-price-alerts.skypicker.com",
  graphqlApiUrl: "https://graphql.kiwi.com/",
  metaApiUrl: "https://api.skypicker.com/meta-search",
  logladyApiUrl: "https://loglady.kiwi.com/frontend",
  ancillariesApiUrl: "https://horst.skypicker.com",
  imagesUrl: "//images.kiwi.com/",
  accountGraphqlApi: "https://plexus-prod.skypicker.com/graphql",
  mmb2BasePath: "",
  androidAppId: "com.skypicker.main",

  mozioEnabledLangs: [
    "en-US",
    "en-GB",
    "af-ZA",
    "zh-CN",
    "zh-TW",
    "cs-CZ",
    "hr-HR",
    "da-DK",
    "nl-NL",
    "fi-FI",
    "fr-FR",
    "de-DE",
    "el-GR",
    "id-ID",
    "it-IT",
    "ja-JP",
    "lt-LT",
    "lv-LV",
    "ms-MY",
    "no-NO",
    "pl-PL",
    "pt-PT",
    "ro-RO",
    "ru-RU",
    "es-ES",
    "sv-SE",
    "tl-PH",
    "th-TH",
    "tr-TR",
    "uk-UA",
    "vi-VN",
  ],

  travelCarEnabledLangs: [
    "es-AR",
    "de-BE",
    "fr-BE",
    "nl-BE",
    "pt-BR",
    "bg-BG",
    "en-CA",
    "fr-CA",
    "es-CO",
    "el-CY",
    "cs-CZ",
    "de-DE",
    "es-ES",
    "en-EU",
    "fr-FR",
    "el-GR",
    "hr-HR",
    "hu-HU",
    "en-IE",
    "it-IT",
    "en-MT",
    "fr-MA",
    "es-MX",
    "nl-NL",
    "en-NZ",
    "es-PE",
    "pl-PL",
    "pt-PT",
    "ro-RO",
    "ru-RU",
    "de-CH",
    "en-ZA",
    "fr-CH",
    "it-CH",
    "sv-SE",
    "tr-TR",
    "uk-UA",
    "en-GB",
    "en-US",
    "de-AT",
    "zh-CN",
  ],

  parkcloudEnabledLangs: [
    "en-GB",
    "cs-CZ",
    "de-DE",
    "es-ES",
    "fr-FR",
    "hu-HU",
    "it-IT",
    "lt-LT",
    "nl-NL",
    "pl-PL",
    "pt-PT",
    "ro-RO",
    "ru-RU",
    "tr-TR",
  ],

  twitter: "kiwicom247",
  userAppAppId: "5433ecccaff67",
  kayakPartnerId: "skypicker",
  affiliateWindowAdvertiserId: "6682",
  googleConversionId: "940725268",
  continents: ["ap", "aas", "eu", "mea"],
  bookingComOneWayDefaultNights: "5",
  FREE_POBEDA_BAG_WEIGHT: "10",
  stagingEnvironmentUrl: ".fe-cloudrun.kiwi.com",
  airlinesWithSplitFees: ["AC", "AF", "KL", "WA", "FC"],
  soonDepartureThresholdHours: "24",
  maxSearchMonths: "9",

  pgpKey:
    "-----BEGIN PGP PUBLIC KEY BLOCK-----\n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\nNZhZQbmQ2ROhu0bGaA==\n=03tx\n-----END PGP PUBLIC KEY BLOCK-----\n",

  totalBookingsStat: "3 600 000+",
  dailyQueriesStat: "100 000 000",
  priceUpdatesStat: "225 000+",
  seatsSoldStat: "40 000",
  flightCombinations: "14,057,075,465",
  airlinesWithDisallowedPromocode: ["SU", "S7"],
  airlinesWithBagsDisclaimer: ["FR", "OE"],
}
